import * as React from 'react';
import styles from './Error.css';
import * as arrowNext from '!svgson-loader!@paradigm/icons/src/mailru/navigation/arrow_list_next.svg';
import * as done from '!svgson-loader!@paradigm/icons/src/mailru/status/done.svg';
import * as error from '!svgson-loader!@paradigm/icons/src/mailru/status/error.svg';
import { Svgson } from 'svgson-loader';
import { Icon } from '2kit';
import classnames from 'classnames';
import { pluralize } from '@/helpers/pluralize';

interface ErrorProps {
	warningMessages: string[] | null;
	errorMessages?: string[] | null;
}

const configErrors = {
	one: 'ошибка',
	two: 'ошибки',
	five: 'ошибок',
};

const foundErrors = {
	one: 'Найдена',
	two: 'Найдено',
	five: 'Найдено',
};

const Error: React.FunctionComponent<ErrorProps> = ({ errorMessages }) => {
	const [isOpen, setIsOpen] = React.useState(true);

	const onOpenButtonClick = (): void => {
		setIsOpen(!isOpen);
	};

	const getActionIcon = (): React.ReactElement => {
		const isError = errorMessages && errorMessages.length > 0;

		const icon = isError ? error : done;
		const className = classnames({
			[styles.errorIcon]: isError,
			[styles.doneIcon]: !isError,
		});

		return (
			<div className={className}>
				<Icon icon={icon as Svgson} />
			</div>
		);
	};

	return (
		<div className={styles.container}>
			<div className={styles.errorBlock}>
				{(!errorMessages || errorMessages.length === 0) && (
					<div className={styles.noErrorTitleBlock}>
						{getActionIcon()}
						<div className={styles.mainMessage}>Ошибок не найдено</div>
					</div>
				)}

				{errorMessages && errorMessages.length > 0 && (
					<div className={styles.errorTitleContainer}>
						<div className={styles.errorTitleBlock}>
							{getActionIcon()}
							<div className={styles.mainMessage}>
								{`${pluralize(
									errorMessages.length,
									foundErrors.one,
									foundErrors.two,
									foundErrors.five,
								)} 
								${errorMessages.length} 
								${pluralize(
						errorMessages.length,
						configErrors.one,
						configErrors.two,
						configErrors.five,
					)}`
								}
							</div>
						</div>

						<div
							className={classnames({
								[styles.iconDown]: isOpen,
								[styles.iconUp]: !isOpen,
							})}
							onClick={onOpenButtonClick}
						>
							<Icon icon={arrowNext as Svgson} />
						</div>
					</div>
				)}

				{errorMessages && errorMessages.length > 0 && isOpen && (
					<ul className={styles.list}>
						{errorMessages && errorMessages.map((errorMessage: string, index) => (
							<li className={styles.errorMessage} key={index}>
								{errorMessage}
							</li>
						))}
					</ul>
				)}
			</div>
		</div>
	);
};

export default Error;
